import React from "react";

import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

export const ConfigIcon = () => {
  const {
    state: { theme },
  } = useGlobalContext();
  const isDarkMode = theme.value === "dark";

  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.46502 1.65783C8.46521 1.44846 9.51003 1.44185 10.5332 1.65576C10.6659 2.52543 11.1781 3.32907 11.9993 3.80315C12.8204 4.27722 13.7725 4.31901 14.592 3.9991C15.2889 4.77826 15.8055 5.6864 16.1243 6.65727C15.4384 7.20706 14.9993 8.05188 14.9993 8.99928C14.9993 9.94728 15.4389 10.7925 16.1255 11.3423C15.967 11.8226 15.7573 12.294 15.4944 12.7493C15.2316 13.2046 14.9282 13.6219 14.5914 13.9993C13.7721 13.6796 12.8202 13.7215 11.9993 14.1954C11.1788 14.6691 10.6668 15.4719 10.5335 16.3408C9.53336 16.5501 8.48853 16.5567 7.46533 16.3428C7.33262 15.4732 6.82039 14.6695 5.99926 14.1954C5.17814 13.7214 4.22605 13.6796 3.40655 13.9995C2.70969 13.2204 2.193 12.3122 1.87424 11.3413C2.5601 10.7916 2.99927 9.94668 2.99927 8.99928C2.99927 8.05135 2.55959 7.20608 1.87305 6.65631C2.03151 6.17599 2.24121 5.70459 2.50407 5.2493C2.76694 4.794 3.07033 4.3767 3.40707 3.9993C4.22646 4.31898 5.17831 4.27713 5.99926 3.80315C6.81974 3.32944 7.33181 2.5267 7.46502 1.65783ZM8.99928 11.2493C10.2419 11.2493 11.2493 10.242 11.2493 8.99928C11.2493 7.75668 10.2419 6.7493 8.99928 6.7493C7.75661 6.7493 6.74926 7.75668 6.74926 8.99928C6.74926 10.242 7.75661 11.2493 8.99928 11.2493Z"
        fill={isDarkMode ? "#F2F2F2" : "#050505bf"}
      />
    </svg>
  );
};
